import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import selectSeatingOrder from '../selectSeatingOrder'
import { status as Status } from '@bt-react/constants'
import { Role } from '../../constants/roles'
import username from '../../../lib/username'
import selectObservers from '../selectObservers'
import { StructuredPresenterInterface } from '../structuredSelectPresenter/types'
import getPresentersFromSeatingOrder from '../getPresentersFromSeatingOrder'

const getFocusedBridge = (state: State): boolean => state.config.bridgeName === state.config.activeBridge
const getGigLive = (state: State): boolean =>
  state.ui.status === Status.LIVE ||
  state.ui.status === Status.OVERRUN
const getPresenters = (state: State): StructuredPresenterInterface[] => getPresentersFromSeatingOrder(state)
const getObservers = (state: State): StructuredPresenterInterface[] => selectObservers(state)
const getPlayInInitiator = (state: State): string | null => state.playIn.initiatedBy
const getLocalBTID = (state: State): string => state.user.BTID || ''
const getLocalRole = (state: State): Role => username.getRoleFromUsername(state.config.username ?? '')
const getActiveBridge = (state: State): boolean => !!state.config.activeBridge

/**
 * Determines whether a bridge is set, if so, is this instance the primary bridge; if not, am I the focused presenter
 */
export default () => createSelector(
  [
    getFocusedBridge,
    getGigLive,
    getPlayInInitiator,
    selectSeatingOrder,
    getPresenters,
    getObservers,
    getLocalBTID,
    getLocalRole,
    getActiveBridge
  ],
  (isFocusedBridge, isGigLive, initiatedBy, seatingOrder: string[], presenters, observers, BTID, localRole, hasActiveBridge): boolean => {

    if (hasActiveBridge && isGigLive) return isFocusedBridge

    if (!isGigLive) {
      if (!initiatedBy || (typeof presenters.find(({id}) => id === initiatedBy ) === 'undefined' && typeof observers.find(({id}) => id.replace('brightTALK-observer-', '') === initiatedBy ) === 'undefined')) {

        const mediaPresenter = seatingOrder.find(identity => identity !== initiatedBy)
        return mediaPresenter === BTID

      }
      else {

        return initiatedBy === BTID

      }
    }

    if (localRole === 'WATCH') return true

    return false

  }

)
